import { toCamelCase } from '@/helpers';

export default function (name) {
  return `__vue${toCamelCase(name, true)}__`;
}
